import axios from 'axios';

export const csrfToken = document.head.querySelector('meta[name=csrf-token]')
  ? document.head.querySelector('meta[name=csrf-token]').content
  : '';

const headers = {
  'X-CSRF-Token': csrfToken,
  'Content-Type': 'application/json',
  Accept: '*/*'
};

try {
  if (window.location !== window.parent.location) {
    // in an iframe
    // When the site is open in an iframe by EdIncites, Cobb we need to inform the server
    let iframedBy = sessionStorage.getItem('iframed_by');
    if (iframedBy) {
      iframedBy = JSON.parse(iframedBy);
      headers['X-IFRAMED'] = iframedBy.name;
    }
  }
} catch (error) {}

const apiRequest = axios.create({
  headers
});

global.axiosRequests = 0;

apiRequest.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    global.axiosRequests += 1;
    return config;
  },
  (error) => {
    global.axiosRequests -= 1;
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiRequest.interceptors.response.use(
  (response) => {
    // Do something with response data
    global.axiosRequests -= 1;
    return response;
  },
  (error) => {
    global.axiosRequests -= 1;
    // Do something with response error
    return Promise.reject(error);
  }
);

export default apiRequest;
